import { useEffect, useState } from "react";
import { tv } from "tailwind-variants";

import type { Option } from "@/utils";
import { Checkbox } from "./checkbox";

const multiSelectVariants = tv({
  base: "w-full",
});

export type MultiSelectProps = {
  options?: Option[];
  value?: string[];
  onChange?: (value: string[]) => void;
  label?: string;
  error?: string | boolean;
  disabled?: boolean;
  containerClassName?: string;
  optionClassName?: string;
};

export const MultiSelect = ({
  containerClassName,
  disabled,
  error,
  onChange,
  optionClassName,
  options,
  value = [],
}: MultiSelectProps) => {
  const [selectedValues, setSelectedValues] = useState<string[]>(value ?? []);

  useEffect(() => {
    setSelectedValues(value ?? []);
  }, [value]);

  const handleOptionChange = (optionId: string, checked: boolean) => {
    let newValues: string[];

    if (checked) {
      newValues = [...selectedValues, optionId];
    } else {
      newValues = selectedValues.filter((id) => {
        return id !== optionId;
      });
    }

    setSelectedValues(newValues);

    onChange?.(newValues);
  };

  return (
    <div className={multiSelectVariants({ className: containerClassName })}>
      <div className="flex flex-col gap-2">
        {options?.map((option) => {
          return (
            <Checkbox
              checked={selectedValues.includes(option.label)}
              containerClassName={optionClassName}
              disabled={disabled}
              id={`multiselect-${option.label}-${option.value}`}
              key={`multiselect-${option.label}-${option.value}`}
              label={option.label}
              onChange={(checked) => {
                return handleOptionChange(option.label, checked);
              }}
            />
          );
        })}
      </div>

      {error && typeof error === "string" ? (
        <p className="mt-2 text-sm font-medium text-danger-content" role="alert">
          {error}
        </p>
      ) : null}
    </div>
  );
};
